import { notification } from "antd";
import axiosInstance from "../axiosInstance";
import { BrandPersonality } from "../../pages/Enterprise/modules/BrandPersonality/types";

const getBrandPersonality = async (
  id: string,
  mainAccountId?: string
): Promise<BrandPersonality> => {
  try {
    const response = await axiosInstance.get<BrandPersonality>(
      `/tone-and-voice/${id}`,
      {
        params: {
          mainAccountId,
        },
      }
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível retornar o Tom e Voz.",
    });

    throw new Error(`${error}`);
  }
};

const deleteBrandPersonality = async (
  id: string,
  mainAccountId?: string
): Promise<BrandPersonality> => {
  try {
    const response = await axiosInstance.delete<BrandPersonality>(
      `/tone-and-voice/${id}`,
      {
        params: {
          mainAccountId,
        },
      }
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível deletar o Tom e Voz.",
    });

    throw new Error(`${error}`);
  }
};

const createBrandPersonality = async (
  id: string,
  data: BrandPersonality,
  mainAccountId?: string
): Promise<BrandPersonality> => {
  try {
    const queryParams = mainAccountId ? `?mainAccountId=${mainAccountId}` : "";
    const response = await axiosInstance.post<BrandPersonality>(
      `/tone-and-voice/${id}${queryParams}`,
      data
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível criar o Tom e Voz.",
    });

    throw new Error(`${error}`);
  }
};

export const brandPersonalityService = {
  getBrandPersonality,
  createBrandPersonality,
  deleteBrandPersonality,
};
